import styles from "./Header.module.css";
import logo from "../../../assets/logo.svg";

export default function Header({ title, modifiedDate, description }) {
  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <div className={styles.logo}>
          <img src={logo} alt="" />
          <div className={styles.appTitle}>StartAppify</div>
        </div>

        <div className={styles.pageTitle}>{title}</div>
      </div>
      {modifiedDate && (
        <div className={styles.modifiedDate}>Last Modified: {modifiedDate}</div>
      )}
      {description && <div className={styles.desc}>{description}</div>}
    </header>
  );
}
